import { render, staticRenderFns } from "./AddCompanyDocumentModal.vue?vue&type=template&id=f85de5d8"
import script from "./AddCompanyDocumentModal.vue?vue&type=script&lang=js"
export * from "./AddCompanyDocumentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports